





































































	import {Stored} from 'vue-stored-prop-decorator';
	import {Component, Vue} from '@/shared/component';
	import {Emit, Watch} from 'vue-property-decorator';
	import {ResultType} from '@/shared/xhttp';
	import {Fournisseur} from '@/models';

	import CrudFournisseurFilter from '@/components/Crud/Fournisseur/Filter.vue';
	import CrudFournisseurEditDialog from '@/components/Crud/Fournisseur/EditDialog.vue';
	import CrudFournisseurList from '@/components/Crud/Fournisseur/List.vue';
	import CrudDeleteDialog from '@/components/Crud/DeleteDialog.vue';

	import storeFournisseur, {FournisseurFilter} from '@/stores/modules/fournisseur';

	@Component({
		components: {
			CrudFournisseurFilter,
			CrudFournisseurEditDialog,
			CrudFournisseurList,
			CrudDeleteDialog,
		}
	})
	export default class FournisseurListView extends Vue {

		@Stored(() => storeFournisseur) private fournisseurs!: ResultType<Fournisseur>;
		@Stored(() => storeFournisseur) private filters!: FournisseurFilter;

		private imgPath: string = "";

		private editFournisseur: Fournisseur = null;
		private deletedFournisseur: Fournisseur = null;
		private storeFournisseur = storeFournisseur;

		public created(): void {
			this.routeWatcher();
		}

		@Watch('$route')
		private routeWatcher() {
		}

		@Emit()
		private onCreate(): void {
			this.editFournisseur = new Fournisseur();
			this.refresh();
		}

		private refresh(): void {
            storeFournisseur.dispatch('getC', { filters: true });
		}
	}
